import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { useSelector } from 'react-redux';
import {
	AuditOutlined, TeamOutlined, FileTextOutlined
} from '@ant-design/icons';
import styles from './styles';
import { SUPER_ADMIN } from '../../utils/constants';
import {
	ADMINS_ROUTE, INSPECTORSAPPLICATIONS_ROUTE, INSPECTORS_ROUTE, SUPERVISORS_ROUTE,
} from '../../routing/paths';
import logo from '../../assets/logo.png'

const { Sider } = Layout;

const Sidebar = () => {
	let location = useLocation();
	const { role } = useSelector( ( state ) => state.user.user );
	
	const [ selectedKey, setSelectedKey ] = useState( undefined );

	useEffect( () => {
		setSelectedKey( location.pathname );
	}, [ location ] );
	return (
		<Sider
			style = {styles.sider}
		>
			<section style={styles.logoSection}>
				<img alt="logo" src={logo} style={styles.logo} />
			</section>
			<Menu mode="inline" selectedKeys={[ selectedKey ]}>
				{role == SUPER_ADMIN && (
					<Menu.Item key={ADMINS_ROUTE} icon={<AuditOutlined />}>
						<Link to={ADMINS_ROUTE}>Administradores</Link>
					</Menu.Item>
				)}
				 <Menu.Item key={INSPECTORS_ROUTE} icon={<TeamOutlined />}>
					<Link to={INSPECTORS_ROUTE}>Inspectores</Link>
				</Menu.Item>
				<Menu.Item key={SUPERVISORS_ROUTE} icon={<TeamOutlined />}>
					<Link to={SUPERVISORS_ROUTE}>Supervisores</Link>
				</Menu.Item>
				<Menu.Item key={INSPECTORSAPPLICATIONS_ROUTE} icon={<FileTextOutlined />}>
					<Link to={INSPECTORSAPPLICATIONS_ROUTE}>Solicitudes de inspección</Link>
				</Menu.Item>

			</Menu>
		</Sider>
	);
};

export default Sidebar;
